<template>
  <div>
    <!--面包屑-->
    <breadcrumb-link></breadcrumb-link>
    <!--内容区域-->
    <div>
      <!--查询条件-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" ref="filters">
          <el-form-item 
            label="提交服务名称" 
            prop="name" 
          >
            <el-input v-model="name" placeholder="提交服务名称"></el-input>
          </el-form-item>
          <el-form-item 
            label="创建日期"
            prop="createTime" 
          >
            <el-date-picker
              v-model="createTime"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <!--查询、重置、新增-->
      <ws-btn-area
        :config="btnAreaConfig"
      ></ws-btn-area>
      <!--table-->
      <ws-table
        :config="tableConfig"
        :tableData="tableData"
        :pageConfig="page"
       :header-cell-style="{background:'#f2f2f2'}"
      ></ws-table>
    </div>
  </div>
</template>

<script>
  import BreadcrumbLink from '../../../components/breadcrumbLink';
  import wsTable from '../../../components/wsTable'
  import wsBtnArea from '../../../components/wsBtnArea'
  import { setBtnAreaConfig, setTableConfig } from './config.js'

  import util from '@/utils/util';
  import {powerMixin} from '@/utils/mixin';
  import {
    getServiceList,
    deleteService
  } from '@/apis/pipelineService/pipelineConfig';

  export default {
    mixins: [powerMixin],
    components: {
      BreadcrumbLink,
      wsTable,
      wsBtnArea
    },
    data() {
      return {
        moduleName: '/virtualNumber',
        code: '', // 列表无数据默认值
        message: '', // 列表无数据默认值
        name: null,
        createTime:null,
        searchOptions: {},
        btnAreaConfig: setBtnAreaConfig.call(this),
        tableConfig: setTableConfig.call(this),
        tableData: [],
        page: {
          pageNo: 1,
          pageSize: 10,
          total: 0,
          handleSizeChange: (size) => {
            this.page.pageSize = size
            this.getList();
          },
          handleCurrentChange: (page) => {
            this.page.pageNo = page
            this.getList();
          }
        }
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      //查询
      getListCX() {
        let startTime = this.createTime ? util.formatDate(this.createTime[0]) + ' 00:00:00' : null
        let endTime =this.createTime? util.formatDate(this.createTime[1]) + ' 00:00:00' : null
        this.page.pageNo = 1
        this.searchOptions = {
          name: this.name,
          startTime,
          endTime
        };
        this.getList();
      },
      //重置筛选条件
      resetForm(formName) {
        this.name = null,
        this.createTime = null,
        this.searchOptions = {};
        this.page.pageNo = 1;
        this.getList();
      },
      // 跳转详情
      goForm(type, id) {
        this.$router.push({
          path: '/serviceConfigForm',
          query: {
            type,
            id,
          }
        });
      },
      del (id) {
        this.$confirm('是否确认删除该提交服务？')
          .then(() => {
            this.deleteService(id)
          })
          .catch((error) => {console.log(error)});
      },
      // 删除数据
      async deleteService(id) {
        let params = {
          id,
        }
        const data = await deleteService(params);
        if(data.code ==  0) {
          this.$message.success(data.message)
          this.getList()
        }else {
          this.$message.error(data.message)
        }
      },
      // 获取列表数据
      async getList() {
        let params = {
          ...this.searchOptions,
          current: this.page.pageNo, //当前页
          size: this.page.pageSize, //当前条数
        };
        try {
          const data = await getServiceList(params);
          if (data.code == 0 && data.data) {
            this.tableData = data.data.records;
            this.page.total = data.data.total
          }else {
            this.$message.error(data.message)
          }
        } catch (error) {
        }
      }
    }
  };
</script>

<style scoped>

</style>

